import * as React from 'react';
export const IcCloudExclamation = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21.7 13.46c-.33-.8-.92-1.47-1.67-1.91.01-.18.01-.36 0-.53 0-1.3-.43-2.57-1.22-3.61a5.963 5.963 0 00-3.17-2.12c-1.26-.34-2.6-.25-3.8.25-1.2.5-2.21 1.38-2.86 2.51-.68.04-1.33.25-1.9.61-.57.36-1.04.87-1.36 1.46-1.08.17-2.06.74-2.75 1.59a4.407 4.407 0 00.34 5.91c.78.77 1.82 1.22 2.91 1.27h11.83c.87 0 1.71-.29 2.4-.82s1.18-1.27 1.41-2.11c.22-.84.17-1.73-.16-2.53v.03zM13 17c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm1-4c0 .55-.45 1-1 1s-1-.45-1-1V9c0-.55.45-1 1-1s1 .45 1 1v4z'
      fill='currentColor'
    />
  </svg>
);
